import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import RestApi from '../../Apis/RestApi';

const EmailVerification = () => {
  const [status, setStatus] = useState('loading');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const success = params.get('success');
    const error = params.get('error');

    // If we have a token, we need to verify it
    if (token) {
      const verifyEmail = async () => {
        try {
          const response = await RestApi.verifyEmail(token);
          setStatus('success');
          toast.success('Email verified successfully!');
          
          // Redirect after 3 seconds
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } catch (error) {
          setStatus('error');
          toast.error('Verification failed: ' + (error.response?.data?.message || 'Unknown error'));
        }
      };
      verifyEmail();
    } 
    // If we already have a success or error parameter, we've been redirected from the backend
    else if (success === 'true') {
      setStatus('success');
      toast.success('Email verified successfully!');
      
      // Redirect after 3 seconds
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } else if (success === 'false') {
      setStatus('error');
      toast.error('Verification failed: ' + (error || 'Unknown error'));
    }
  }, [navigate, location]);

  return (
    <div className='h-screen w-screen bg-slate-900 flex justify-center items-center'>
      <div className='text-center'>
        <h1 className='text-white text-7xl mb-8'>Email Verification</h1>
        
        {status === 'loading' && (
          <p className='text-white text-2xl'>Verifying your email...</p>
        )}
        
        {status === 'success' && (
          <>
            <p className='text-white text-2xl mb-4'>Your email has been successfully verified!</p>
            <p className='text-white text-xl'>Redirecting you to login page...</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <p className='text-white text-2xl mb-4'>We couldn't verify your email.</p>
            <p className='text-white text-xl'>Please try again or contact support.</p>
            <button 
              className='mt-8 bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600'
              onClick={() => navigate('/login')}
            >
              Go to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;